import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// Every Team page query sits under "team", so invalidating TEAM_QUERY_KEY refreshes the roster and the stat cards at once.
export const TEAM_QUERY_KEY = ["team"] as const;
export const TEAM_ROSTER_QUERY_KEY = [...TEAM_QUERY_KEY, "roster"] as const;
export const TEAM_STATS_QUERY_KEY = [...TEAM_QUERY_KEY, "stats"] as const;
// Writes mark these queries stale explicitly, so they needn't refetch on every focus or remount — on a
// large department the roster is ~1.5MB. Same window as the department roster's `useRosterLookup`.
export const TEAM_QUERY_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Mark the Team page's queries stale after a write. The page reads its roster and stat cards from its own
 * queries, so a write that only refreshes `hospitalData` never reaches it.
 *
 * Pass `TEAM_QUERY_KEY` when the write changed nurses (both the roster and the cards), or a narrower key when it
 * touched only that part. Invalidates by prefix, so it's a no-op when the page isn't open.
 *
 * A standalone module so HospitalDataProvider can call it without importing the query hooks.
 */
export const useInvalidateTeamQueries = () => {
	const queryClient = useQueryClient();
	return useCallback((queryKey: readonly string[]) => queryClient.invalidateQueries({ queryKey }), [queryClient]);
};
